import { useFeatureFlag } from '@spotify/confidence-flag-evaluation-react';
import { useAccountMode } from '@spotify/confidence-graphql';

export const useIsConfidenceCloud = (): {
  loading: boolean;
  confidenceCloudFlagEnabled: boolean;
  isConfidenceCloud: boolean;
} => {
  const { enabled } = useFeatureFlag<{ enabled: boolean }>(
    'managed-warehouse',
    {
      enabled: false,
    },
  );

  const { loading, hasConfidenceCloud, hasCustomerWarehouse } =
    useAccountMode();

  return {
    loading,
    confidenceCloudFlagEnabled: enabled,
    isConfidenceCloud: enabled && hasConfidenceCloud && !hasCustomerWarehouse,
  };
};
